import { atom, useRecoilValue, useSetRecoilState, selector } from 'recoil';

const extractQueryContextFromResponse = ({
  ident,
  userlogid,
  maincat,
  currentChannel,
  currentBA,
}) => ({
  ident,
  userlogid,
  businessArea: currentBA,
  Channel: currentChannel,
  mainCat: maincat,
});

/**
 * Chatbot query response
 */
const chatbotQueryResponseState = atom({
  key: 'chatbotQueryDetail',
  default: {},
});

export const useChatbotQueryResponseState = () =>
  useRecoilValue(chatbotQueryResponseState);

export const useSetChatbotQueryResponseState = () =>
  useSetRecoilState(chatbotQueryResponseState);

/**
 * Chatbot query context
 */
const chatbotQueryContextState = selector({
  key: 'chatbotQueryContext',
  get: ({ get }) => {
    const context = extractQueryContextFromResponse(
      get(chatbotQueryResponseState) || {},
    );

    return {
      queryContext: context,
      hasQueryContext: !!context.ident,
    };
  },
});

export const useChatbotQueryContext = () =>
  useRecoilValue(chatbotQueryContextState);
